import { createModel } from '@/store/tools';

const model = {
    namespace: 'help_strategy',
    build: (T, A, S, R) => ({
        actiontypes: {

            'getTableSource': T('getTableSource'),

            'getStateList': T('getStateList'),
            'getArticleTableSource': T('getArticleTableSource'),

            'getDetail': T('getDetail'),
        },
        actions: {

            'getTableSource': A('getTableSource'),

            'getStateList': A('getStateList'),
            'getArticleTableSource': A('getArticleTableSource'),

            'getDetail': A('getDetail'),
        },
        sagas: {
            'getTableSource': S('getTableSource', '/?cmd=com.xqxc.api.pig.mis.biz.platform.StrategyMisService.listStrategyClass'),

            'getStateList': S('getStateList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getArticleTableSource': S('getArticleTableSource', '/?cmd=com.xqxc.api.pig.mis.biz.platform.StrategyMisService.listStrategyInfo'),

            'getDetail': S('getDetail', '/ad/detail'),
        },
        reducers: {
            'tableSource': R('getTableSource', []),

            'stateList': R('getStateList', []),
            'articleTableSource': R('getArticleTableSource', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),

            'detail': R('getDetail', {}),
        }
    })
};
export default createModel(model);